export default {
  queryCsAppealList: '/gateway/capp/courier_operations/queryCsAppealList'
}
